import { css } from 'styled-components';
import {
  BreakpointQueryName, SpacingName, TypographyName, getTypography, getSpacing, ThemedFunctor,
} from '@doveit/bricks';
// eslint-disable-next-line import/no-cycle
import { StripeDirection } from './Stripe';

export const base: ThemedFunctor = ({
  theme,
  $direction,
}) => css`
  display: flex;
  flex-direction: column-reverse;
  align-items: start;
  margin: 0 auto;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    flex-direction: ${$direction === StripeDirection.LEFT_TO_RIGHT ? 'row' : 'row-reverse'};
  }
`;

export const content: ThemedFunctor = ({
  theme,
  $direction,
  $alignContent,
}) => css`
  align-items: start;
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;

  ${$alignContent && `
    align-items: ${$alignContent};
  `}

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    ${$direction === StripeDirection.LEFT_TO_RIGHT
    ? getSpacing.marginLeft(theme, SpacingName.SMALL)
    : getSpacing.marginRight(theme, SpacingName.SMALL)}
  }
`;

export const picture: ThemedFunctor = ({
  theme,
}) => css`
  margin: 0 auto;
  margin-top: ${theme.spaceUnits.mobile.MEDIUM};
  min-width: 100%;
  border-radius: 6px;
  overflow: hidden;

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    margin-top: 0;
    max-width: 20rem;
    flex-shrink: 0;
    min-width: auto;
  }
`;

export const title: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H4)}
`;

export const description: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.BODY)}
  ${getSpacing.marginTop(theme, SpacingName.SMALLER)}
  max-width: 40rem;
`;

export const actions: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.marginTop(theme, SpacingName.SMALL)}

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
  }
`;
